import type { Annotation, Communication } from 'fhir/r4';
import React from 'react';
import { Dimmer, Form, Header, Loader, TextArea } from 'semantic-ui-react';
import type { CommunicationData } from 'types';

import ErrorMessages from '../errorMessages';

import { CommunicationNoteFormContainer } from './communicationNoteForm.styles';
import GroupNote from './groupNote';
import useCommunicationNote from './useCommunicationNote';


type CommunicationNoteFormProps = {
  communicationPayload: Communication;
  isNew?: boolean | undefined; // flag for new UI using the communication note
  isUnknownCaller: boolean;
  noteList: Annotation[];
  orgId?: string | undefined;
  patientId?: string | undefined;
  refresh: () => Promise<CommunicationData | void>;
  subject: string | undefined;
  isMutable: boolean;
};

const CommunicationNoteForm: React.FC<CommunicationNoteFormProps> = ({
  communicationPayload,
  isNew,
  isUnknownCaller,
  noteList,
  orgId,
  patientId,
  refresh,
  subject,
  isMutable,
}) => {
  const {
    handleSelectedNote,
    handleSubmit,
    isDeleting,
    isSubmitting,
    note,
    removeNote,
    selectedNote,
    setNote,
    validationErrors,
  } = useCommunicationNote({ communicationPayload, isUnknownCaller, noteList, orgId, patientId, refresh, subject });

  const onNoteChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    setNote((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    isMutable
      ? <CommunicationNoteFormContainer>
        <Header style={{ fontSize: '14px' }}>NOTES</Header>
        <Form onSubmit={handleSubmit}>
          <Form.Group widths="equal">
            <Form.Field
              id="form-input-control-note-text"
              rows={3}
              control={TextArea}
              name="noteText"
              value={note.noteText}
              cols={2}
              placeholder="Add Note"
              onChange={onNoteChange}
              required
            //maxLength="40"
            />
          </Form.Group>
          <Form.Group>
            <Form.Button loading={isSubmitting} size="medium" color="blue" content="Add Note" />
          </Form.Group>
        </Form>
        <Dimmer active={isDeleting} inverted>
          <Loader />
        </Dimmer>
        {/* Omits `onClearError`, so this panel has no dismiss control. KNOWN_BUGS.md CM-20. */}
        {validationErrors.length ? (
          <ErrorMessages
            {...({ validationErrors } as React.ComponentProps<typeof ErrorMessages>)}
          />
        ) : null}
        {/* We will only show group notes if the isSubmitting is false */}
        {!isSubmitting && (
          <GroupNote
            handleSelectedNote={handleSelectedNote}
            isNew={isNew}
            isSubmitting={isSubmitting}
            noteList={noteList}
            removeNote={removeNote}
            selectedNote={selectedNote}
          />
        )}
      </CommunicationNoteFormContainer>
      : <CommunicationNoteFormContainer>
        <GroupNote
          handleSelectedNote={handleSelectedNote}
          isNew={isNew}
          isSubmitting={isSubmitting}
          noteList={noteList}
          //removeNote={removeNote}
          selectedNote={selectedNote}
        />
      </CommunicationNoteFormContainer>
  );
};

export default CommunicationNoteForm;
